import type { JSX } from 'react';
import React from 'react';

import type { IIntegrationPageFrameProps } from '@feathr/components';

import Page from '../Page';

/** The extender `Page` as the Integration UI Kit's frame, with the expanded header from Figma. */
function IntegrationPageFrame(props: Readonly<IIntegrationPageFrameProps>): JSX.Element {
  return <Page collapseHeader={false} collapseHeaderOnScroll={true} {...props} />;
}

export default IntegrationPageFrame;
